import { Grid } from '@material-ui/core'
import CustomField from 'elements/field/CustomField'
import CheckboxInput from 'elements/input/CheckboxInput'
import DependentInput from 'elements/input/DependentInput'
import { ComponentVersions_3_0, ComponentVersionsInherit, FormLabel } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import { SelectInput, TextInput } from 'ra-ui-materialui'
import React, { useEffect, useState } from 'react'
import { useFormState } from 'react-final-form'
import { HostedDisclosureType } from '../types'
import { DAYS_BY_MONTH, getYearChoices, MONTHS } from './constants'
import { formatSSN, parseIncome, parseSSN } from './utils'

type PropTypes = {
  onClose: () => void
  disclosures: HostedDisclosureType[]
}

type ChoiceType = {
  name: string
  id: string
}

const EnFinApplicationForm: React.FC<PropTypes> = (props) => {
  const [primaryDOBDayChoices, setPrimaryDOBDayChoices] = useState<ChoiceType[]>([])
  const [secondaryDOBDayChoices, setSecondaryDOBDayChoices] = useState<ChoiceType[]>([])

  const formState = useFormState()

  useEffect(() => {
    setPrimaryDOBDayChoices(getDayChoices(formState?.values?.applicantPersonalInformation?.[0]?.dobMonth))
  }, [formState?.values?.applicantPersonalInformation?.[0]?.dobMonth])

  useEffect(() => {
    setSecondaryDOBDayChoices(getDayChoices(formState?.values?.applicantPersonalInformation?.[1]?.dobMonth))
  }, [formState?.values?.applicantPersonalInformation?.[1]?.dobMonth])

  const getDayChoices = (selectedMonth: string) => {
    return selectedMonth &&
      !isNaN(parseInt(selectedMonth)) &&
      parseInt(selectedMonth) > 0 &&
      parseInt(selectedMonth) < 13
      ? // @ts-ignore
        DAYS_BY_MONTH[selectedMonth]
      : DAYS_BY_MONTH['none']
  }

  const renderBorrowerFields = (index) => {
    return (
      <>
        <Grid item xs={6}>
          <FormLabel>{translate('First Name')}</FormLabel>
          <CustomField
            name={`applicantPersonalInformation.${index}.firstName`}
            source={`applicantPersonalInformation.${index}.firstName`}
            label={false}
            component={TextInput}
            fullWidth
            style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
          />
        </Grid>
        <Grid item xs={6}>
          <FormLabel>{translate('Last Name')}</FormLabel>
          <CustomField
            name={`applicantPersonalInformation.${index}.lastName`}
            source={`applicantPersonalInformation.${index}.lastName`}
            label={false}
            component={TextInput}
            fullWidth
            style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
          />
        </Grid>
        <Grid item xs={6}>
          <FormLabel>{translate('Phone Number')}</FormLabel>
          <CustomField
            name={`applicantPersonalInformation.${index}.mobileNumber`}
            source={`applicantPersonalInformation.${index}.mobileNumber`}
            label={false}
            component={TextInput}
            fullWidth
            style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
          />
        </Grid>
        <Grid item xs={6}>
          <FormLabel>{translate('Email Address')}</FormLabel>
          <CustomField
            name={`applicantPersonalInformation.${index}.emailAddress`}
            source={`applicantPersonalInformation.${index}.emailAddress`}
            label={false}
            component={TextInput}
            fullWidth
            style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
          />
        </Grid>
        <Grid item xs={12}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <span style={{ fontWeight: 900 }}>{translate('Date of Birth')}</span>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ flex: 1, padding: '0px 4px' }}>
                <FormLabel>{translate('Month')}</FormLabel>
                <CustomField
                  name={`applicantPersonalInformation.${index}.dobMonth`}
                  source={`applicantPersonalInformation.${index}.dobMonth`}
                  label={false}
                  component={SelectInput}
                  choices={MONTHS}
                  fullWidth
                  style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
                />
              </div>
              <div style={{ flex: 1, padding: '0px 4px' }}>
                <FormLabel>{translate('Day')}</FormLabel>
                <CustomField
                  name={`applicantPersonalInformation.${index}.dobDay`}
                  source={`applicantPersonalInformation.${index}.dobDay`}
                  label={false}
                  component={SelectInput}
                  choices={index === 0 ? primaryDOBDayChoices : secondaryDOBDayChoices}
                  fullWidth
                  style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
                />
              </div>
              <div style={{ flex: 1, padding: '0px 4px' }}>
                <FormLabel>{translate('Year')}</FormLabel>
                <CustomField
                  name={`applicantPersonalInformation.${index}.dobYear`}
                  source={`applicantPersonalInformation.${index}.dobYear`}
                  label={false}
                  component={SelectInput}
                  choices={getYearChoices()}
                  fullWidth
                  style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
                />
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormLabel>{translate('Social Security Number')}</FormLabel>
          <CustomField
            name={`applicantPersonalInformation.${index}.ssn`}
            source={`applicantPersonalInformation.${index}.ssn`}
            label={false}
            component={TextInput}
            fullWidth
            style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
            parse={parseSSN}
            format={formatSSN}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormLabel>{translate('Pre-Tax Annual Income')}</FormLabel>
          <CustomField
            name={`applicantPersonalInformation.${index}.annualIncome`}
            source={`applicantPersonalInformation.${index}.annualIncome`}
            label={false}
            component={TextInput}
            fullWidth
            parse={parseIncome}
            style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomField
            name={`applicantPersonalInformation.${index}.lives_somewhere_else`}
            source={`applicantPersonalInformation.${index}.lives_somewhere_else`}
            label={translate('The site of installation is NOT my primary address')}
            component={(checkboxProps: any) => <CheckboxInput {...checkboxProps} elStyle={{ maxWidth: '900px' }} />}
            fullWidth
            required
            style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
          />
        </Grid>
        {formState.values?.applicantPersonalInformation?.[index]?.lives_somewhere_else && (
          <>
            <Grid item xs={12}>
              <FormLabel>{translate('Street Address')}</FormLabel>
              <CustomField
                name={`applicantPersonalInformation.${index}.primaryAddress`}
                source={`applicantPersonalInformation.${index}.primaryAddress`}
                label={false}
                component={TextInput}
                fullWidth
                style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormLabel>{translate('City')}</FormLabel>
              <CustomField
                name={`applicantPersonalInformation.${index}.city`}
                source={`applicantPersonalInformation.${index}.city`}
                label={false}
                component={TextInput}
                fullWidth
                style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
              />
            </Grid>
            <Grid item xs={3}>
              <FormLabel>{translate('State')}</FormLabel>
              <CustomField
                name={`applicantPersonalInformation.${index}.state`}
                source={`applicantPersonalInformation.${index}.state`}
                label={false}
                component={TextInput}
                fullWidth
                style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
              />
            </Grid>
            <Grid item xs={3}>
              <FormLabel>{translate('Zip Code')}</FormLabel>
              <CustomField
                name={`applicantPersonalInformation.${index}.zipCode`}
                source={`applicantPersonalInformation.${index}.zipCode`}
                label={false}
                component={TextInput}
                fullWidth
                style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
              />
            </Grid>
          </>
        )}
      </>
    )
  }

  const translate = useTranslate()
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <h2>{translate('Primary Borrower Information')}</h2>
      </Grid>
      {renderBorrowerFields(0)}
      <Grid item xs={12}>
        <h2>{translate('Co-Borrower Information')}</h2>
      </Grid>
      <Grid item xs={12}>
        <CustomField
          name="has_coborrower"
          source="has_coborrower"
          label={translate("I'd like to add a co-borrower")}
          component={(checkboxProps: any) => <CheckboxInput {...checkboxProps} elStyle={{ maxWidth: '900px' }} />}
          fullWidth
          required
          style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
        />
      </Grid>
      <DependentInput dependsOn="has_coborrower" value={true}>
        {renderBorrowerFields(1)}
      </DependentInput>
      <Grid item xs={12}>
        <h4>{translate('Installation Site')}</h4>
      </Grid>
      <Grid item xs={12}>
        <FormLabel>{translate('Street Address')}</FormLabel>
        <CustomField
          name="installationAddress.streetAddress"
          source="installationAddress.streetAddress"
          label={false}
          component={TextInput}
          fullWidth
          style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
        />
      </Grid>
      <Grid item xs={6}>
        <FormLabel>{translate('City')}</FormLabel>
        <CustomField
          name="installationAddress.city"
          source="installationAddress.city"
          label={false}
          component={TextInput}
          fullWidth
          style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
        />
      </Grid>
      <Grid item xs={3}>
        <FormLabel>{translate('State')}</FormLabel>
        <CustomField
          name="installationAddress.state"
          source="installationAddress.state"
          label={false}
          component={TextInput}
          fullWidth
          style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
        />
      </Grid>
      <Grid item xs={3}>
        <FormLabel>{translate('Zip')}</FormLabel>
        <CustomField
          name="installationAddress.zipCode"
          source="installationAddress.zipCode"
          label={false}
          component={TextInput}
          fullWidth
          style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
        />
      </Grid>
      <CustomField
        name="agreed_to_terms"
        source="agreed_to_terms"
        label={translate('I agree to the terms and conditions listed below')}
        component={(checkboxProps: any) => <CheckboxInput {...checkboxProps} elStyle={{ maxWidth: '900px' }} />}
        fullWidth
        required
        style={{ width: '100%', margin: '5px 0px', padding: '0px' }}
      />
      <>
        <div>
          {props.disclosures?.map((disc) => (
            <p className="small">{disc.content}</p>
          ))}
        </div>
      </>
    </Grid>
    </ComponentVersionsInherit>
  )
}

export default EnFinApplicationForm
